import React, { ChangeEvent, useState } from "react";
import cloneDeep from "lodash/cloneDeep";
//@ts-ignore
import Ico from "images/ico.svg";

type ArquivoSalvo = {
  id: number;
  titulo: string;
  url: string;
  canRemove: boolean;
  _destroy?: boolean;
};

type ArquivoNovo = {
  id: number;
  titulo: string;
  file?: any;
};

type Props = {
  arquivosSalvos: ArquivoSalvo[];
  enabled: boolean;
  minimoArquivosObrigatorio: number;
};

export function FormRelatorioUploadArquivos({
  arquivosSalvos: arquivosSalvosProps,
  enabled,
  minimoArquivosObrigatorio,
}: Props) {
  const [arquivosSalvos, setArquivosSalvos] =
    useState<ArquivoSalvo[]>(arquivosSalvosProps);
  const [arquivosNovos, setArquivosNovos] = useState<ArquivoNovo[]>(
    minimoArquivosObrigatorio &&
      minimoArquivosObrigatorio > 0 &&
      arquivosSalvosProps.length == 0
      ? (function () {
          let result = [];
          for (let i = 0; i < minimoArquivosObrigatorio; i++) {
            result.push({
              id: Date.now() + i,
              titulo: "",
            });
          }
          return result;
        })()
      : []
  );

  const [arquivoSendoEditadoId, setArquivoSendoEditadoId] = useState<number | null>(null);
  const [titulosEditados, setTitulosEditados] = useState<Record<number, string>>({});


  const toogleExclusaoArquivoSalvo = (arquivo: ArquivoSalvo) => {
    const copyArquivos = cloneDeep(arquivosSalvos);
    const index = copyArquivos.findIndex((arq) => arq.id === arquivo.id);
    if (index === -1) return;

    copyArquivos[index]._destroy = !copyArquivos[index]._destroy;
    setArquivosSalvos(copyArquivos);
  };

  const adicionarArquivo = () => {
    const novoArquivo: ArquivoNovo = {
      id: Date.now(),
      titulo: "",
    };
    setArquivosNovos([...arquivosNovos, novoArquivo]);
  };

  const handleNomeChange = (id: number, titulo: string) => {
    setArquivosNovos((prevArquivos) =>
      prevArquivos.map((arquivo) =>
        arquivo.id === id ? { ...arquivo, titulo } : arquivo
      )
    );
  };

  const handleFileChange = (id: number, e: ChangeEvent<HTMLInputElement>) => {
    setArquivosNovos((prevArquivos) =>
      prevArquivos.map((arquivo) =>
        arquivo.id === id
          ? {
              ...arquivo,
              file:
                e.target.files && e.target.files.length > 0
                  ? e.target.files[0]
                  : undefined,
            }
          : arquivo
      )
    );
  };

  const removerArquivoNovo = (id: number) => {
    setArquivosNovos((prevArquivos) =>
      prevArquivos.filter((arquivo) => arquivo.id !== id)
    );
  };

  if (arquivosSalvos.length == 0 && !enabled) {
    return null;
  }

  const qtdArquivos =
    arquivosSalvos.filter((arquivo) => {
      return !arquivo._destroy;
    }).length + arquivosNovos.length;

  return (
    <div className="margem-superior grid-12">

      <span className="margem-direita-1">
        {minimoArquivosObrigatorio && minimoArquivosObrigatorio > 0
          ? `Anexar arquivos (mínimo obrigatório: ${minimoArquivosObrigatorio})`
          : "Anexar arquivos (opcional)"}
      </span>
      {arquivosSalvos.length > 0 && (
        <table className="tab tab--form">
          <thead>
            <th className="alinha-esquerda col-w-85">Arquivos anexados</th>
            <th className="col-w-15"></th>
          </thead>
          <tbody>
            {arquivosSalvos.map((arquivoSalvo, index) => {
              return (
                <tr key={arquivoSalvo.id}>
                  <td className="alinha-esquerda" title={arquivoSalvo.titulo}>
                    {arquivoSendoEditadoId === arquivoSalvo.id ? (
                        <input
                            type="text"
                            autoFocus
                            value={titulosEditados[arquivoSalvo.id] ?? arquivoSalvo.titulo}
                            onChange={(e) =>
                                setTitulosEditados({
                                  ...titulosEditados,
                                  [arquivoSalvo.id]: e.target.value,
                                })
                            }
                            onBlur={() => setArquivoSendoEditadoId(null)}
                            name={`relatorio[relatorios_arquivos_anexos_attributes][${index}][titulo]`}
                            style={{ width: "100%", height: "48px" }}
                        />
                    ) : (
                        <a
                          className="texto"
                            href={arquivoSalvo.url}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                          {titulosEditados[arquivoSalvo.id] ?? arquivoSalvo.titulo}
                        </a>
                    )}
                  </td>

                  <td className="tab__acoes">
                    {!enabled && arquivoSendoEditadoId !== arquivoSalvo.id && (
                      <a className="bt" 
                          href={arquivoSalvo.url}
                          target="_blank"
                          rel="noopener noreferrer">
                            Visualizar
                      </a>
                    )}
                    {enabled &&
                      arquivoSalvo._destroy &&
                      arquivoSalvo.canRemove && (
                        <button
                          type="button"
                          className="bt"
                          title="desfazer-exclusão"
                          onClick={() =>
                            toogleExclusaoArquivoSalvo(arquivoSalvo)
                          }
                        >
                          Desfazer exclusão
                        </button>
                      )}
                    {enabled &&
                        !arquivoSalvo._destroy &&
                        arquivoSalvo.canRemove && (
                            <>
                              <button
                                  type="button"
                                  className="bt"
                                  title="renomear"
                                  onClick={() => setArquivoSendoEditadoId(arquivoSalvo.id)}
                              >
                                Renomear
                              </button>
                              {qtdArquivos > minimoArquivosObrigatorio && (
                                  <button
                                      type="button"
                                      className="bt bt--urgente"
                                      title="excluir"
                                      onClick={() => toogleExclusaoArquivoSalvo(arquivoSalvo)}
                                  >
                                    Excluir
                                  </button>
                              )}
                            </>
                        )}

                  </td>
                  <input
                    type="hidden"
                    name={`relatorio[relatorios_arquivos_anexos_attributes][${index}][id]`}
                    value={arquivoSalvo.id}
                  />
                  {arquivoSalvo._destroy && (
                    <input
                      type="hidden"
                      name={`relatorio[relatorios_arquivos_anexos_attributes][${index}][_destroy]`}
                      value="true"
                    />
                  )}
                  <input
                      type="hidden"
                      name={`relatorio[relatorios_arquivos_anexos_attributes][${index}][titulo]`}
                      value={titulosEditados[arquivoSalvo.id] ?? arquivoSalvo.titulo}
                  />
                </tr>
              );
            })}
          </tbody>
        </table>
      )}

      {enabled && arquivosNovos.length > 0 && (
          <div className="grid-12">
            <div className="mensagem mensagem--aviso">
              ⚠️ Atenção: as imagens anexadas serão levemente reduzidas em qualidade ao serem salvas.
            </div>
          </div>
      )}

      {enabled &&
          arquivosNovos.map((arquivoNovo, index) => {
            return (
                <div className="container container--form" key={arquivoNovo.id}>


                <label className="form grid-6 grid--m-12">
                <input
                  required={true}
                  type="text"
                  name={`relatorio[relatorios_arquivos_anexos_attributes][${
                    index + arquivosSalvos.length
                  }][titulo]`}
                  value={arquivoNovo.titulo}
                  onChange={(e) =>
                    handleNomeChange(arquivoNovo.id, e.target.value)
                  }
                />
                <span className="label margem-superior-p">Título</span>
              </label>
              <label className="form margem-superior-p grid-4 grid--m-11">
                <input
                  className="margem-esquerda"
                  required={true}
                  type="file"
                  name={`relatorio[relatorios_arquivos_anexos_attributes][${
                    index + arquivosSalvos.length
                  }][arquivo_anexo]`}
                  onChange={(e) => handleFileChange(arquivoNovo.id, e)}
                  accept="application/pdf, image/jpeg, image/png"
                />
                <span className="label">Arquivo</span>
                <span className="form__file-info">
                  {Ico ? (
                    <svg className="ico margem-direita-p">
                      <use xlinkHref={`${Ico}#upload`} />
                    </svg>
                  ) : (
                    "x"
                  )}
                  {arquivoNovo.file
                    ? arquivoNovo.file.name
                    : "Selecione o arquivo"}
                </span>
              </label>

              {(!minimoArquivosObrigatorio ||
                qtdArquivos > minimoArquivosObrigatorio) && (
                <button
                  className="bt form__bt--remover"
                  type="button"
                  onClick={() => removerArquivoNovo(arquivoNovo.id)}
                >
                  Remover
                </button>
              )}
            </div>
          );
        })}
        {enabled && (
          <button
            type="button"
            className="bt margem-superior"
            onClick={adicionarArquivo}
          >
            Adicionar anexo
          </button>
      )}
    </div>
  );
}
